export default __webpack_public_path__ + "static/media/image_8.0d979bf0.jpg";